// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Pj2pz","formContainer":"styles_formContainer__4f5xh","btnWrapper":"styles_btnWrapper__i8Mfg","btn":"styles_btn__p-Rqc"};